<template><!-- svgo-optimised -->
<svg class="icon icon__loading" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 12c0-5.52285-4.4772-10-10-10C6.47715 2 2 6.47715 2 12H0C0 5.37258 5.37258 0 12 0c6.6274 0 12 5.37258 12 12h-2z"/></svg>
</template>